import styled from 'styled-components'

export const Container = styled.section`
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 216px 32px 100px;
  width: 100%;

  @media (max-width: 950px) {
    padding: 62px 32px 19px;
  }
`

export const Content = styled.div`
  align-items: flex-end;
  display: flex;
  gap: 32px;
  justify-content: space-between;
  max-width: 1032px;
  width: 100%;

  @media (max-width: 950px) {
    align-items: flex-start;
    flex-direction: column;
    gap: 62px;
    max-width: 613px;
  }
`

export const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  max-width: 432px;

  h1 {
    font-size: 32px;
    line-height: 40px;
  }

  p {
    font-size: 24px;
  }

  @media (max-width: 950px) {
    max-width: initial;
  }

  @media (max-width: 764px) {
    h1 {
      font-size: 24px;
      line-height: 32px;
    }

    p {
      font-size: 16px;
      line-height: 24px;
    }
  }
`

export const ImageContainer = styled.div`
  align-items: flex-end;
  aspect-ratio: 508 / 709;
  display: flex;
  max-width: 508px;
  width: 100%;
`

export const ImageBg = styled.div`
  aspect-ratio: 1;
  background-color: var(--primary);
  border-radius: 20px;
  max-width: 508px;
  height: auto;
  max-height: 508px;
  position: relative;
  padding-inline: 14px;
  width: 100%;

  img {
    position: absolute;
    bottom: 0;
    max-width: calc(100% - 28px);
  }
`
